import { FieldTypes } from '../../../constants/FieldTypes'
import { addFieldRow } from '../../../fields/utils'
import {
  BloodPressureField,
  CheckboxField,
  FieldMap,
  HeightField,
  NumberField,
} from '../../../types/forms/fields'

export const heightField: HeightField = {
  type: FieldTypes.HEIGHT,
  placeholder: 'Height',
  optional: true,
}

export const weightField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Weight',
  unit: 'lbs',
  min: 0,
  max: 500,
  optional: true,
  warningMessage: 'Weight is a standard component of antepartum care per ACNM guidelines.',
}

export const temperatureField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Temperature',
  unit: '°F',
  step: 0.1,
  precision: 1,
  min: 90,
  max: 110,
  optional: true,
  warningMessage: 'Temperature is recommended to assess for fever or infection.',
}

export const bloodPressureField: BloodPressureField = {
  type: FieldTypes.BLOOD_PRESSURE,
  placeholder: 'Blood Pressure',
  optional: true,
}

export const pulseField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Pulse',
  unit: 'bpm',
  min: 0,
  max: 300,
  optional: true,
  warningMessage: 'Pulse is a standard vital sign for antepartum care.',
}

export const respiratoryRateField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Respiratory Rate',
  unit: 'breaths/min',
  min: 0,
  max: 60,
  optional: true,
}

// §2.4: Tier 3 — auto-promotes to Tier 1 if respiratory complaint is documented.
export const o2SaturationField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'O2 Saturation',
  unit: '%',
  min: 50,
  max: 100,
  step: 1,
  optional: true,
}

export const vitalSignsField: FieldMap = {
  name: 'Vital Signs',
  children: {
    height: addFieldRow(heightField, { index: 0, flex: 1 }),
    weight: addFieldRow(weightField, { index: 0, flex: 1 }),
    temperature: addFieldRow(temperatureField, { index: 1, flex: 1 }),
    bloodPressure: addFieldRow(bloodPressureField, { index: 1, flex: 1 }),
    pulse: addFieldRow(pulseField, { index: 2, flex: 1 }),
    respiratoryRate: addFieldRow(respiratoryRateField, { index: 2, flex: 1 }),
    o2Saturation: addFieldRow(o2SaturationField, { index: 3, flex: 1 }),
  },
}

export const hasVitalsField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Vital Signs',
  size: 'lg',
}
